import { ApiResponse } from 'apisauce';
import { ErrorResponse } from '../../../../lib/basicRepository';
import { HTTP_STATUS } from '../../../../utils/httpStatus.const';

const offlineRepositoryError = <T, K>(message: string): Promise<ApiResponse<T, K>> => {
  const error: ErrorResponse = {
    message,
    status: HTTP_STATUS.NOT_IMPLEMENTED,
  };

  return Promise.resolve({
    ok: false,
    status: HTTP_STATUS.NOT_IMPLEMENTED,
    data: error,
  } as ApiResponse<T, K>);
};

export const notImplementedInOfflineError = <T, K>(
  methodName: string,
): Promise<ApiResponse<T, K>> => {
  const message = `${methodName} não implementado no modo offline`;
  return offlineRepositoryError<T, K>(message);
};

export const filterNotAvailableInOfflineError = <T, K>(): Promise<ApiResponse<T, K>> => {
  const message = 'filtro não disponível no modo offline';
  return offlineRepositoryError<T, K>(message);
};
